import { render, staticRenderFns } from "./TopSonIncidenceDetails.vue?vue&type=template&id=6119c856&scoped=true"
import script from "./TopSonIncidenceDetails.vue?vue&type=script&lang=js"
export * from "./TopSonIncidenceDetails.vue?vue&type=script&lang=js"
import style0 from "./TopSonIncidenceDetails.vue?vue&type=style&index=0&id=6119c856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119c856",
  null
  
)

export default component.exports